import * as client_hooks from '../../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54')
];

export const server_loads = [0];

export const dictionary = {
		"/(default)/(site)": [12,[3,4]],
		"/(default)/admin": [29,[3,6]],
		"/(default)/admin/chats": [30,[3,6]],
		"/(default)/admin/chats/[id]": [31,[3,6]],
		"/(default)/admin/configuracion/desembolsos": [32,[3,6]],
		"/(default)/admin/configuracion/empresas": [33,[3,6]],
		"/(default)/admin/configuracion/notificaciones": [34,[3,6]],
		"/(default)/admin/configuracion/productos": [35,[3,6]],
		"/(default)/admin/configuracion/sistema": [36,[3,6]],
		"/(default)/admin/configuracion/usuarios": [37,[3,6]],
		"/(default)/admin/errores": [38,[3,6]],
		"/(default)/admin/errores/[id]": [39,[3,6]],
		"/(default)/admin/pagos": [40,[3,6]],
		"/(default)/admin/pagos/[code]": [41,[3,6]],
		"/(default)/admin/reportes/desembolsos": [42,[3,6]],
		"/(default)/admin/reportes/desembolsos/[id]": [43,[3,6]],
		"/(default)/admin/reportes/exportar": [44,[3,6]],
		"/(default)/admin/reportes/exportar/nueva": [45,[3,6]],
		"/(default)/admin/reportes/puntored": [46,[3,6]],
		"/(default)/admin/reportes/puntored/archivo": [47,[3,6]],
		"/(default)/admin/suscripciones-de-notificacion": [48,[3,6]],
		"/(default)/admin/suscripciones-de-notificacion/importar": [50,[3,6]],
		"/(default)/admin/suscripciones-de-notificacion/importar/[id]": [51,[3,6]],
		"/(default)/admin/suscripciones-de-notificacion/[id]": [49,[3,6]],
		"/(bot)/bot/cerrar-ventana": [9,[2]],
		"/(bot)/bot/historial": [10,[2]],
		"/(bot)/bot/pagar": [11,[2]],
		"/(default)/(site)/cerrar-ventana": [13,[3,4]],
		"/(default)/(site)/color-test": [14,[3,4]],
		"/(default)/(site)/confirmacion/[code]": [15,[3,4]],
		"/(default)/dev/ui": [52,[3,7]],
		"/(default)/dev/ui/[component]": [53,[3,7,8]],
		"/(default)/dev/ui/[component]/frame": [54,[3,7,8]],
		"/(default)/(site)/empresas/[slug]": [16,[3,4]],
		"/(default)/(site)/redirect": [17,[3,4],[,,5]],
		"/(default)/(site)/sin-permiso": [18,[3,4]],
		"/(default)/(site)/terminos": [19,[3,4]],
		"/(default)/(site)/usuario/contrasena/restablecer": [20,[3,4]],
		"/(default)/(site)/usuario/contrasena/solicitar-restablecimiento": [21,[3,4]],
		"/(default)/(site)/usuario/historial": [22,[3,4]],
		"/(default)/(site)/usuario/ingresar-whatsapp": [24,[3,4]],
		"/(default)/(site)/usuario/ingresar": [23,[3,4]],
		"/(default)/(site)/usuario/registrar": [25,[3,4]],
		"/(default)/(site)/usuario/solicitar-verificacion": [26,[3,4]],
		"/(default)/(site)/usuario/verificacion": [27,[3,4]],
		"/(default)/(site)/vincular-whatsapp": [28,[3,4]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);